module.exports = __webpack_public_path__ + "img/logo.d43633ac.svg";